var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgImageLoader = function SvgImageLoader(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "inner-svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50 35.5c-8.008 0-14.5 6.492-14.5 14.5S41.992 64.5 50 64.5 64.5 58.008 64.5 50v-1.5h3V50c0 9.665-7.835 17.5-17.5 17.5S32.5 59.665 32.5 50 40.335 32.5 50 32.5h1.5v3H50Z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "outer-svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.342 73.666c13.07-3.502 20.826-16.936 17.324-30.006C70.164 30.59 56.73 22.834 43.66 26.336c-13.07 3.502-20.826 16.936-17.324 30.006l.388 1.449-2.898.776-.388-1.449c-3.93-14.67 4.775-29.75 19.445-33.68 14.67-3.93 29.75 4.775 33.68 19.445 3.932 14.67-4.774 29.75-19.445 33.68l-1.448.39-.777-2.899 1.449-.388Z",
    fill: "url(#b)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 64.5,
    y1: 48.5,
    x2: 60,
    y2: 26.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 44,
    y1: 90.5,
    x2: 23.883,
    y2: 58.779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })))));
};
export default SvgImageLoader;